import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";

import * as modalActions from "../../actions/modalActions";

import CustomerService from "../../services/customerService";

import HeaderWrapper from "../common/HeaderWrapper";
import CustomerList from "./CustomerList";
import ConfirmModal from "../common/ConfirmModal";

const DEFAULT_PAGE_SIZE = localStorage.getItem(
  "DEFAULT_PAGE_SIZE_CONTRACT_LIST"
)
  ? parseInt(localStorage.getItem("DEFAULT_PAGE_SIZE_CONTRACT_LIST"))
  : 10;
const CustomerPage = ({ isMobile, history }) => {
  const [search, setSearch] = useState("");
  const [customerToDelete, setCustomerToDelete] = useState("");

  const [totalResults, setTotalResults] = useState(0);

  const dispatch = useDispatch();

  let listRef = useRef(null);

  const onPageSizeChange = (pageSize) => {
    localStorage.setItem("DEFAULT_PAGE_SIZE_CONTRACT_LIST", pageSize);
  };

  const onClickView = (id) => {
    history.push(`/app/customers/${id}`);
  };

  const onClickDelete = (id) => {
    setCustomerToDelete(id);
    dispatch(modalActions.showModalSuccess("customerDeleteModal"));
  };

  const handleDelete = async () => {
    await CustomerService.deleteCustomer(customerToDelete);
    await listRef.table.fireFetchData();
  };

  const filter = (e) => {
    setSearch(e.target.value.replaceAll("\\", ""));
  };

  const closeModal = (id) => {
    dispatch(modalActions.hideModal(id));
  };

  return (
    <React.Fragment>
      <HeaderWrapper
        breadcrumbs={[{ label: `Customers (${totalResults} customers)` }]}
        onFilter={filter}
        isMobile={isMobile}
      />
      <div className="content-wrapper">
        <CustomerList
          ref={(l) => (listRef = l)}
          filtered={search}
          isMobile={isMobile}
          setTotalResults={setTotalResults}
          onClickView={onClickView}
          onClickDelete={onClickDelete}
          onPageSizeChange={onPageSizeChange}
          defaultPageSize={DEFAULT_PAGE_SIZE}
        />
      </div>
      <ConfirmModal
        id="customerDeleteModal"
        title="Delete Customer"
        body="Are you sure you want to delete this customer?"
        confirm={handleDelete}
        close={closeModal}
      />
    </React.Fragment>
  );
};

CustomerPage.propTypes = {
  isMobile: PropTypes.bool,
  history: PropTypes.object
};

export default CustomerPage;
